module.exports = __webpack_public_path__ + "media/images/countrysquared/co-5e2013d56bf61ed1539612eaaf7f4a2d.svg";